import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { InputForm } from 'controls/Input'
import { Button } from 'controls'
import Spinner from 'controls/Spinner'
import { TentativeParentsActionCreators } from 'app/reducers/TentativeParentsRedux'
import { getTentativeParentsSearchResults, getTentativeParentsSearchLoading } from 'app/selectors/TentativeParentsSelectors'
import styles from './searcherStyles'

class ParentSearcher extends Component {
  constructor(props) {
    super(props)
    this.state = {
      searchTerm: '',
      showResults: false,
    }
    this.searchTimeout = null
  }

  handleSearchChange = event => {
    const searchTerm = event.target.value
    this.setState({ searchTerm })

    // Clear previous timeout
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }

    if (searchTerm.trim().length >= 2) {
      // Debounce search by 500ms
      this.searchTimeout = setTimeout(() => {
        this.props.searchParents(searchTerm)
        this.setState({ showResults: true })
      }, 500)
    } else {
      this.setState({ showResults: false })
      this.props.clearSearchResults()
    }
  }

  handleSelectParent = parent => {
    if (this.props.onParentSelected) {
      this.props.onParentSelected(parent)
    }
    
    // Clear search after selection
    this.setState({ 
      searchTerm: '', 
      showResults: false 
    })
    this.props.clearSearchResults()
  }

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
  }

  render() {
    const { searchTerm, showResults } = this.state
    const { searchResults, isSearchLoading } = this.props

    return (
      <div className="parent-searcher">
        <div className="search-container">
          <InputForm
            value={searchTerm}
            onChange={this.handleSearchChange}
            placeholder="Buscar padrino por nombre, ID, email..."
            label="Buscar Padrino"
          />
        </div>

        {showResults && (
          <div className="search-results">
            {isSearchLoading ? (
              <div className="loading">
                <span>Buscando padrinos...</span>
              </div>
            ) : searchResults.length > 0 ? (
              <div className="results-list">
                <h6>Resultados de búsqueda:</h6>
                {searchResults.map(result => {
                  const {user} = result
                  const fullName = user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() : 'N/A'
                  
                  return (
                    <div key={result.id} className="search-result-item">
                      <div className="parent-info">
                        <div className="parent-name">{fullName}</div>
                        <div className="parent-email">{user?.email || 'N/A'}</div>
                        <div className="parent-phone">{user?.telephone || 'N/A'}</div>
                      </div>
                      <div className="parent-actions">
                        <Button
                          color="primary"
                          size="small"
                          onClick={() => this.handleSelectParent(result)}
                        >
                          Elegir
                        </Button>
                      </div>
                    </div>
                  )
                })}
              </div>
            ) : searchTerm.trim().length >= 2 ? (
              <div className="no-results">
                No se encontraron padrinos que coincidan con la búsqueda.
              </div>
            ) : null}
          </div>
        )}
        <style jsx>{styles}</style>
      </div>
    )
  }
}

ParentSearcher.propTypes = {
  // Redux props
  searchResults: PropTypes.array.isRequired,
  isSearchLoading: PropTypes.bool.isRequired,
  searchParents: PropTypes.func.isRequired,
  clearSearchResults: PropTypes.func.isRequired,
  // Callback props
  onParentSelected: PropTypes.func,
}

ParentSearcher.defaultProps = {
  onParentSelected: null,
}

const mapStateToProps = state => ({
  searchResults: getTentativeParentsSearchResults(state),
  isSearchLoading: getTentativeParentsSearchLoading(state),
})

const mapDispatchToProps = dispatch => ({
  searchParents: (searchTerm) => dispatch(TentativeParentsActionCreators.search(searchTerm)),
  clearSearchResults: () => dispatch(TentativeParentsActionCreators.clearSearch()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ParentSearcher)
